import * as React from 'react';

interface DoneMessageState {
    hidden: boolean;
}

interface DoneMessageProps {
    label: string;
    duration?: number;
}

/**
 * Shows message (set by props.label) on bottom of screen.
 * After duration (set by props.duration or default 2.5sec) the message fades out by css opacity transition.
 * CSS Transition takes 1.5sec.
 */
export class DoneMessage extends React.Component<DoneMessageProps, DoneMessageState> {
    protected hideTimer: number | null;

    public componentWillMount(): void {
        this.setState({hidden: false});
    }

    public componentWillUnmount(): void {
        if (this.hideTimer != null) {
            clearTimeout(this.hideTimer);
            this.hideTimer = null;
        }
    }

    public componentDidMount(): void {
        this.hideTimer = window.setTimeout(
            () => { this.setState({hidden: true}); },
            this.props.duration ? this.props.duration : 2500
        );
    }

    public render(): JSX.Element {
        return (
            <div className="ui-core-done-message" style={this.state.hidden ? {opacity: 0} : {}}>
                <div className="ui-core-done-message-box">
                    <div className="ui-core-done-message-label">{this.props.label}</div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DoneMessage.tsx